import React from 'react';
import PropTypes from 'prop-types';

class StoryBlock extends React.PureComponent {
  render() {
    return (
      <div className="block story" id="story">
        <div className="container">
          <div className="title">{this.props.tt.story.title}</div>
          <div
            className="text"
            dangerouslySetInnerHTML={{
              __html: this.props.tt.story.text
            }}
          />
          <div className="box-block" />
          <div className="robbit" />
        </div>
      </div>
    );
  }
}


StoryBlock.propTypes = {
  tt: PropTypes.object,
};

StoryBlock.defaultProps = {
  tt: {},
};


export default StoryBlock;



// WEBPACK FOOTER //
// ./src/HomePage/blocks/StoryBlock/index.js